export default [{
  path: 'fuelCardManage',
  name: 'fuelCardManage',
  component: function component() {
    return import('@/views/fuelCardManage/fuelCard/index');
  }
}, {
  path: 'fuelCardRecordUpdate',
  //油卡维护
  name: 'fuelCardRecordUpdate',
  component: function component() {
    return import('@/views/fuelCardManage/fuelCard/update');
  }
}, {
  path: 'fuelCardRecordManage',
  name: 'fuelCardRecordManage',
  component: function component() {
    return import('@/views/fuelCardManage/fuelRecord/index');
  }
}, {
  path: 'fuelCardRecordAdd',
  name: 'fuelCardRecordAdd',
  component: function component() {
    return import('@/views/fuelCardManage/fuelRecord/add');
  }
}, {
  path: 'fuelRecordUpdate',
  name: 'fuelRecordUpdate',
  component: function component() {
    return import('@/views/fuelCardManage/fuelRecord/update');
  }
}, {
  path: 'fuelCardRecordStatistics',
  name: 'fuelCardRecordStatistics',
  component: function component() {
    return import('@/views/fuelCardManage/fuelRecord/statistics');
  }
}, {
  path: 'fuelCardRecordDetails',
  name: 'fuelCardRecordDetails',
  component: function component() {
    return import('@/views/fuelCardManage/fuelRecord/details');
  }
}, {
  path: 'fuelCardRecordDetailsMap',
  name: 'fuelCardRecordDetailsMap',
  component: function component() {
    return import('@/views/equipmentOperation/base/fuelCardRecordDetailsMap');
  }
}, {
  path: 'fuelRecordDetails',
  name: 'fuelRecordDetails',
  component: function component() {
    return import('@/views/fuelCardManage/recordDetails/index');
  }
}, {
  path: 'fuelRecordImport',
  name: 'fuelRecordImport',
  component: function component() {
    return import('@/views/fuelCardManage/recordDetails/import');
  }
}, {
  path: 'fuelRecordAdd',
  name: 'fuelRecordAdd',
  component: function component() {
    return import('@/views/fuelCardManage/recordDetails/add');
  }
}, {
  path: 'fuelConsumption',
  name: 'fuelConsumption',
  component: function component() {
    return import('@/views/fuelCardManage/fuelConsumption/index');
  }
}, {
  path: 'fuelUse',
  name: 'fuelUse',
  component: function component() {
    return import('@/views/fuelCardManage/fuelUse/index');
  }
}];